import { render, staticRenderFns } from "./AnalyticCreateAdmin.vue?vue&type=template&id=06d6cabc&scoped=true&"
import script from "./AnalyticCreateAdmin.vue?vue&type=script&lang=js&"
export * from "./AnalyticCreateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticCreateAdmin.vue?vue&type=style&index=0&id=06d6cabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6cabc",
  null
  
)

export default component.exports